module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Dedicato a chi ritiene che scriva di loro. Lo faccio. K’A. M.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 1........................................................................... Ammanettala")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 2........................................................................... Serata in famiglia 2")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 3........................................................................... I bikini sono pericolosi 4")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 4........................................................................... I bikini sono pericolosi 5")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 5........................................................................... Sognatrici su internet")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 6........................................................................... Sbaciucchiata")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 7.......................................................................... La cercatrice di pietre preziose")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 8........................................................................... Rubate")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 9........................................................................... Scossa")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 10.......................................................................... La ladra affascinante ~L'Isola dei Serpenti~")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 11.......................................................................... L'amore della mia vita")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 12.......................................................................... Sveltina in ascensore, scendendo?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 13.......................................................................... Nel giardino")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 14.......................................................................... Un ménage à quante?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Racconto 15.......................................................................... Una storia da dimenticare")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Ammanettala")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quanto può essere umiliante essere ammanettati davanti ai propri amici più cari? Due poliziotte scortano Ashley Bingham-Bentley portandola via da una cena elegante e la donna scompare.")]), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Serata in famiglia 2")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Melinda ed Em dimostrano che la “serata della famiglia” può essere ogni settimana differente, in particolare per due donna innamorate.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("I bikini sono pericolosi 4")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Nel mondo Rio de Janeiro è conosciuta come una destinazione turistica nota per le sue spiagge tra cui quelle per nudisti. E io? Indosserò il mio bikini o no? I BIKINI SONO PERICOLOSI!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("I bikini sono pericolosi 5")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando il tuo corpo ti rende insicura, perché non hai un fisico tonico e in forma, le donne che indossano il bikini ti possono distrarre e inibire. Ma più mi alleno, più raggiungo i risultati che desidero e più aumenta la mia attrazione per il tuo corpo appena celato dal bikini. Alla fine ammettere che siamo attratte l'una dall'altra, ci metterà in una situazione che conferma che I BIKINI SONO PERICOLOSI!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Sognatrici su Internet")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Leah è una donna bianca, bionda e fino a poco tempo fa impossibilitata a soddisfare le fantasie che da mesi riguardano l'amica che ha conosciuto su internet. Un'inaspettata eredità le permette di raggiungere la sua amica, forse la sua futura, e appagare sensazioni, desideri e fantasie.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Carmen, una donna latinoamericana, non ha mai provato niente come per questa bionda. E i suoi amici non comprendono perché sia fedele a una donna che non ha mai incontrato.")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando Leah e Carmen si incontrano per la prima volta, fanno scintille insieme!")]), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Sbaciucchiata")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Non so mai cosa accadrà quando la mia ragazza beve troppo e le sue inibizioni scompaiono!")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La cercatrice di pietre preziose")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sam è una donna singolare e cerca quello che vuole nella sua vita, a qualsiasi prezzo. Questa volta si trova nelle isole del Sudest asiatico alla ricerca di diamanti. Si tratta di un lavoro sporco, al caldo e tra i pericoli, ma ne vale la pena quando trova quello per il quale era venuta. L’avventura è grandiosa e trovare una donna che è affascinata da lei è un ulteriore bonus! Felicia si unisce a Sam per il suo nuovo viaggio alla ricerca di queste pietre sfuggenti, ma questa volta l'avventura potrebbe rivelarsi fatale per entrambe...")]), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Rubate")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Amare una donna è difficile. Vivere con una donna è ancora più difficile. Aggiungi dei figli e diventa quasi impossibile, in particolare quando vengono RUBATI!")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sheila ha vissuto un divorzio doloroso. Il suo ex marito è amareggiato e vendicativo. Lasciarlo per un'altra persona, in questo caso una donna, è stato più di quanto quello potesse sopportare e quindi non pensa ad altro che alla vendetta!")]), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Scossa")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Si trova da sola nella lavanderia a gettoni. Può farla franca? Osa farlo? E cosa accadrebbe se fosse scoperta?")]), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("La ladra affascinante ~L'Isola dei Serpenti~")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Che faresti se ti offrissero più denaro per un'unica impresa di quante ne potrebbe guadagnare in un anno la maggior parte della gente? Cosa faresti con della abilità così affinate che solo un ladro potrebbe apprezzarle? Se ti piacesse viaggiare, vedere il mondo e incontrare gente nuova ed emozionante, come potresti sfruttare tutto e farlo diventare la tua “carriera”?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Simone, Marie, Jane, Adelina, Mary o qualsiasi altro nome usi oggi, ha delle abilità uniche e un punto di vista diverso sulla vita. Carina, ma anonima, può usare quasi qualsiasi cosa che abbia a portata di mano per portare il lavoro a termine. Unisciti a lei mentre usa il suo talento per arrivare su una delle isole più pericolose al mondo e riportare al suo cliente quello per il quale l'ha assunta. Porterà a termine il lavoro una volta che scopre di essere stata ingannata? Se non sta attenta, potrebbe rimanere uccisa e potrebbe finire in una prigione del Brasile per il resto dei suoi giorni!")]), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("L'amore della mia VITA")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando incontro l'amore della mia vita, una vorticosa storia d'amore, passione con il lieto fine si avvererà, vero? Il matrimonio finché MORTE non ci separi.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Ascensore, SCENDE?")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Vivere una fantasia nella propria mente è una cosa, ma che questa si avveri è un'altra cosa. Il titolo si spiega da solo!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Nel giardino")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La mia amante da sogno mi trascina in un'avventura... Nel giardino.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Un ménage a quante?")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il sogno di una butch di realizzare una fantasia della sua femme.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Una storia da dimenticare")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Le due peggiori settimane della mia vita!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0